(function () {
  'use strict';

  var root = document.querySelector('[data-ymm-cd]');
  if (!root) return;

  var cfg = {};
  try {
    cfg = JSON.parse(root.querySelector('[data-ymm-cd-config]').textContent);
  } catch (e) {
    cfg = {};
  }

  var TARGET = {
    front: { w: 1423, h: 1411, aspect: 1423 / 1411 },
    insert: { w: 1423, h: 1411, aspect: 1423 / 1411 },
    disc: { w: 1394, h: 1394, aspect: 1 },
    back: { w: 1624, h: 1385, aspect: 1624 / 1385 }
  };

  var STEP_SLIDE = { 1: 'front', 2: 'insert', 3: 'disc', 4: 'back', 5: 'front', 6: 'all', 7: 'all' };
  var FILESTACK = cfg.filestackApiKey || '';
  var defaults = cfg.placeholders || {};

  var state = {
    plane: 'front',
    files: { front: null, insert: null, disc: null, back: null },
    texts: {
      'front-1': mkText(8, 16, 50, '#ffffff'),
      'front-2': mkText(8, 58, 50, '#0b1426'),
      'insert-1': mkText(8, 16, 50, '#ffffff'),
      'insert-2': mkText(8, 58, 50, '#0b1426'),
      'disc-1': mkText(28, 18, 44, '#ffffff'),
      'disc-2': mkText(28, 62, 44, '#0b1426'),
      'back-1': mkText(18, 16, 60, '#ffffff'),
      'back-2': mkText(18, 52, 60, '#0b1426'),
      'back-sl': mkSpine('#ffffff', '#0b1426'),
      'back-sr': mkSpine('#ffffff', '#0b1426')
    },
    crop: null,
    adding: false,
    visited: { 1: true },
    attemptedCheckout: false,
    slide: 'product'
  };

  var STORAGE_KEY = 'ymm_cd_constructor_' + (cfg.variantId || 'default');
  var saveTimer = null;
  var restoring = false;

  function mkText(x, y, w, color) {
    return { text: '', font: 'Jost', size: 28, color: color, x: x, y: y, w: w, bold: false, italic: false, underline: false, align: 'center' };
  }

  function mkSpine(color, bg) {
    return { text: '', font: 'Jost', size: 18, color: color, bg: bg, x: 0, y: 40, w: 80, bold: false, italic: false, underline: false, align: 'center' };
  }

  function $(sel, el) {
    return (el || root).querySelector(sel);
  }

  function $$(sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  }

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var formatted;
    try {
      formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code
      }).format(n / 100);
    } catch (err) {
      formatted = '$' + (n / 100).toFixed(2);
    }
    if (code === 'USD' && formatted.indexOf('USD') === -1) return formatted + ' USD';
    return formatted;
  }

  function qty() {
    var input = $('[data-cd-qty]');
    var n = input ? parseInt(input.value, 10) : 1;
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    if (input) input.value = String(n);
    return n;
  }

  function volumeRate(n) {
    if (n >= 6) return 0.15;
    if (n >= 3) return 0.1;
    return 0;
  }

  function openStep(num, syncSlide) {
    state.visited[num] = true;
    $$('.ymm-cd-step').forEach(function (step) {
      var on = Number(step.getAttribute('data-step')) === num;
      step.classList.toggle('is-open', on);
    });
    if (syncSlide !== false) showSlide(STEP_SLIDE[num] || 'front');
    updateStepMarks();
    saveState();
  }

  function toggleStep(num) {
    var step = $('.ymm-cd-step[data-step="' + num + '"]');
    if (!step) return;
    if (step.classList.contains('is-open')) {
      state.visited[num] = true;
      step.classList.remove('is-open');
      updateStepMarks();
      saveState();
      return;
    }
    openStep(num);
  }

  function revealImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src');
      if (!src) return;
      img.loading = 'eager';
      img.decoding = 'auto';
      if (img.complete && img.naturalWidth > 0) return;
      img.src = src;
    });
  }

  function showSlide(name) {
    state.slide = name;
    $$('.ymm-cd-preview__slide').forEach(function (s) {
      var on = s.getAttribute('data-slide') === name;
      s.classList.toggle('ymm-cd-preview__slide--active', on);
      if (on) revealImages(s);
    });
    $$('.ymm-cd-preview__thumb').forEach(function (t) {
      var on = t.getAttribute('data-target') === name;
      t.classList.toggle('ymm-cd-preview__thumb--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function fileSnap(rec) {
    if (!rec) return null;
    var url = rec.fileUrl && rec.fileUrl.indexOf('blob:') !== 0 && rec.fileUrl.indexOf('data:') !== 0
      ? rec.fileUrl
      : '';
    return {
      name: rec.name || 'upload.jpg',
      origW: rec.origW || 0,
      origH: rec.origH || 0,
      fileUrl: url,
      preview: url || rec.preview || ''
    };
  }

  function saveState() {
    if (restoring) return;
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        var addons = [];
        $$('.ymm-cd-addon input:checked').forEach(function (cb) {
          addons.push(cb.getAttribute('data-variant-id'));
        });
        var order = orderInput();
        var snap = {
          v: 1,
          files: {
            front: fileSnap(state.files.front),
            insert: fileSnap(state.files.insert),
            disc: fileSnap(state.files.disc),
            back: fileSnap(state.files.back)
          },
          texts: state.texts,
          qty: qty(),
          addons: addons,
          visited: state.visited,
          attemptedCheckout: state.attemptedCheckout,
          orderNumber: order ? order.value : '',
          slide: state.slide
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
      } catch (err) {
        try {
          var light = {
            v: 1,
            files: {},
            texts: state.texts,
            qty: qty(),
            visited: state.visited,
            slide: state.slide
          };
          ['front', 'insert', 'disc', 'back'].forEach(function (plane) {
            if (state.files[plane] && state.files[plane].fileUrl) {
              light.files[plane] = fileSnap(state.files[plane]);
            }
          });
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(light));
        } catch (ignored) {}
      }
    }, 300);
  }

  function clearState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (err) {}
  }

  function showFileRow(plane, src) {
    var fileRow = $('.ymm-cd-file[data-plane="' + plane + '"]');
    var uploader = $('.ymm-cd-upload[data-plane="' + plane + '"]');
    if (fileRow) {
      fileRow.classList.add('is-on');
      var thumb = fileRow.querySelector('img');
      if (thumb && src) thumb.src = src;
    }
    if (uploader) uploader.style.display = 'none';
  }

  function applySavedFile(plane, rec) {
    if (!rec || !(rec.fileUrl || rec.preview)) return;
    var src = rec.fileUrl || rec.preview;
    state.files[plane] = {
      name: rec.name || 'upload.jpg',
      origW: rec.origW || 0,
      origH: rec.origH || 0,
      preview: rec.preview || rec.fileUrl,
      blob: null,
      file: null,
      fileUrl: rec.fileUrl || ''
    };
    setPlaneImage(plane, src);
    showFileRow(plane, src);
    if (rec.origW && rec.origH) setQc(plane, rec.origW, rec.origH);
  }

  function textBoxFor(key) {
    if (key === 'back-sl') return $('.ymm-cd-textpanel[data-plane="back"] [data-spine-box="l"]');
    if (key === 'back-sr') return $('.ymm-cd-textpanel[data-plane="back"] [data-spine-box="r"]');
    var parts = key.split('-');
    return $('.ymm-cd-textpanel[data-plane="' + parts[0] + '"] [data-box="' + parts[1] + '"]');
  }

  function restoreTexts(texts) {
    Object.keys(state.texts).forEach(function (key) {
      if (!texts[key]) return;
      state.texts[key] = Object.assign(state.texts[key], texts[key]);
      var box = textBoxFor(key);
      if (!box) {
        syncText(key);
        return;
      }
      var ta = box.querySelector('textarea');
      var font = box.querySelector('[data-font]');
      var size = box.querySelector('[data-size]');
      var picker = box.querySelector('[data-ymm-picker]');
      var hidden = picker ? picker.querySelector('[data-color]') : box.querySelector('[data-color]');
      var hex = picker ? picker.querySelector('[data-hex]') : null;
      if (ta) ta.value = state.texts[key].text || '';
      if (font) font.value = state.texts[key].font || 'Jost';
      if (size) size.value = String(state.texts[key].size || 28);
      if (hidden) hidden.value = state.texts[key].color || '#ffffff';
      if (hex) {
        hex.value = hidden.value;
        hex.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var bgWrap = box.querySelector('[data-ymm-picker-bg]');
      if (bgWrap && state.texts[key].bg) {
        var bgHidden = bgWrap.querySelector('[data-color]');
        var bgHex = bgWrap.querySelector('[data-hex]');
        if (bgHidden) bgHidden.value = state.texts[key].bg;
        if (bgHex) {
          bgHex.value = state.texts[key].bg;
          bgHex.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      paintFormat(box, state.texts[key]);
      syncText(key);
    });
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      if (!snap || snap.v !== 1) return false;
      restoring = true;
      if (snap.files) {
        ['front', 'insert', 'disc', 'back'].forEach(function (plane) {
          applySavedFile(plane, snap.files[plane]);
        });
      }
      if (snap.texts) restoreTexts(snap.texts);
      if (snap.qty) {
        var input = $('[data-cd-qty]');
        if (input) input.value = cfg.requireOrderNumber ? '1' : String(snap.qty);
      }
      if (snap.addons && snap.addons.length) {
        snap.addons.forEach(function (id) {
          var cb = $('.ymm-cd-addon input[data-variant-id="' + id + '"]');
          if (cb) cb.checked = true;
        });
      }
      if (snap.visited) state.visited = Object.assign(state.visited, snap.visited);
      if (snap.attemptedCheckout) state.attemptedCheckout = true;
      var order = orderInput();
      if (order && snap.orderNumber) {
        order.value = String(snap.orderNumber).replace(/\D/g, '').slice(0, 10);
        syncOrderError(false);
      }
      restoring = false;
      return snap;
    } catch (err) {
      restoring = false;
      return false;
    }
  }

  var PRINT_IN = { front: 120.5 / 25.4, insert: 120.5 / 25.4, disc: 118 / 25.4, back: 137.52 / 25.4 };

  function qcPass(plane, w, h) {
    var t = TARGET[plane];
    return w >= t.w && h >= t.h;
  }

  function setQc(plane, w, h) {
    var el = $('.ymm-cd-qc[data-plane="' + plane + '"]');
    if (!el) return;
    var ok = qcPass(plane, w, h);
    var dpi = Math.max(1, Math.round(w / (PRINT_IN[plane] || 10)));
    el.className = 'ymm-cd-qc ' + (ok ? 'ymm-cd-qc--ok' : 'ymm-cd-qc--bad');
    el.textContent = ok ? 'Print ready (' + dpi + ' DPI)' : 'Low quality Print (' + dpi + ' DPI)';
  }

  function setPlaneImage(plane, url) {
    $$('[data-plane-img="' + plane + '"], [data-all="' + plane + '"]').forEach(function (img) {
      if (!url) return;
      img.src = url;
      img.hidden = false;
      img.classList.remove('is-plate');
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (/^https?:/i.test(src)) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function uploadFilestack(blob, name) {
    if (!FILESTACK) return Promise.resolve('');
    return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK, {
      method: 'POST',
      headers: { 'Content-Type': blob.type || 'image/jpeg' },
      body: blob
    }).then(function (res) {
      if (!res.ok) throw new Error('Filestack ' + res.status);
      return res.json();
    }).then(function (data) {
      var url = data.url || '';
      return url ? url + (url.indexOf('?') === -1 ? '?dl=true' : '') : '';
    });
  }

  /* ---------- crop ---------- */

  function openCrop(file, plane) {
    var modal = $('.ymm-cd-crop');
    var stage = $('.ymm-cd-crop__stage');
    var imgEl = $('.ymm-cd-crop__stage img');
    var stageKind = plane === 'disc' ? 'disc' : (plane === 'back' ? 'tray' : 'case');
    stage.className = 'ymm-cd-crop__stage ymm-cd-crop__stage--' + stageKind;
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      imgEl.src = url;
      modal.classList.add('is-on');
      requestAnimationFrame(function () {
        var sw = stage.clientWidth || 1;
        var sh = stage.clientHeight || 1;
        var cover = Math.max(sw / img.width, sh / img.height);
        state.crop = {
          plane: plane,
          file: file,
          img: img,
          objectUrl: url,
          scale: cover,
          x: 0,
          y: 0,
          dragging: false,
          lx: 0,
          ly: 0
        };
        paintCrop();
      });
    };
    img.src = url;
  }

  function paintCrop() {
    var c = state.crop;
    if (!c) return;
    var imgEl = $('.ymm-cd-crop__stage img');
    imgEl.style.width = c.img.width * c.scale + 'px';
    imgEl.style.height = c.img.height * c.scale + 'px';
    imgEl.style.transform = 'translate(calc(-50% + ' + c.x + 'px), calc(-50% + ' + c.y + 'px))';
  }

  function exportCrop() {
    var c = state.crop;
    var t = TARGET[c.plane];
    var stage = $('.ymm-cd-crop__stage');
    var canvas = document.createElement('canvas');
    canvas.width = t.w;
    canvas.height = t.h;
    var ctx = canvas.getContext('2d');
    var scale = t.w / stage.clientWidth;
    var dw = c.img.width * c.scale * scale;
    var dh = c.img.height * c.scale * scale;
    var dx = t.w / 2 + c.x * scale - dw / 2;
    var dy = t.h / 2 + c.y * scale - dh / 2;
    ctx.fillStyle = '#faf9f6';
    ctx.fillRect(0, 0, t.w, t.h);
    ctx.drawImage(c.img, dx, dy, dw, dh);
    return new Promise(function (resolve) {
      canvas.toBlob(function (blob) {
        resolve({ blob: blob, dataUrl: canvas.toDataURL('image/jpeg', 0.92), w: t.w, h: t.h });
      }, 'image/jpeg', 0.92);
    });
  }

  function closeCrop() {
    var modal = $('.ymm-cd-crop');
    modal.classList.remove('is-on');
    if (state.crop && state.crop.objectUrl) URL.revokeObjectURL(state.crop.objectUrl);
    state.crop = null;
  }

  function applyUpload(plane, payload, origW, origH, name) {
    var rec = {
      name: name,
      origW: origW,
      origH: origH,
      preview: payload.dataUrl,
      blob: payload.blob,
      file: state.crop && state.crop.file ? state.crop.file : null,
      fileUrl: ''
    };
    state.files[plane] = rec;
    setPlaneImage(plane, payload.dataUrl);
    showFileRow(plane, payload.dataUrl);
    setQc(plane, origW, origH);
    showSlide(plane === 'insert' ? 'insert' : plane);
    refreshCheckoutButtons();
    saveState();
    uploadFilestack(payload.blob, name).then(function (url) {
      if (url && state.files[plane]) {
        state.files[plane].fileUrl = url;
        saveState();
      }
    }).catch(function () {});
  }

  /* ---------- texts ---------- */

  function textStyle(data) {
    data = data || {};
    var align = data.align === 'left' || data.align === 'right' ? data.align : 'center';
    return { bold: !!data.bold, italic: !!data.italic, underline: !!data.underline, align: align };
  }

  function fontSpec(data, px) {
    var style = textStyle(data);
    return (style.italic ? 'italic ' : '') + (style.bold ? '700 ' : '400 ') + px + 'px "' + ((data && data.font) || 'Jost') + '", sans-serif';
  }

  function paintFormat(box, data) {
    if (!box) return;
    var style = textStyle(data);
    $$('[data-style]', box).forEach(function (btn) {
      btn.setAttribute('aria-pressed', style[btn.getAttribute('data-style')] ? 'true' : 'false');
    });
    $$('[data-align]', box).forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-align') === style.align ? 'true' : 'false');
    });
  }

  function bindFormat(box, key, push) {
    $$('[data-style]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-style');
        state.texts[key][name] = !state.texts[key][name];
        paintFormat(box, state.texts[key]);
        push();
      });
    });
    $$('[data-align]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.texts[key].align = btn.getAttribute('data-align');
        paintFormat(box, state.texts[key]);
        push();
      });
    });
  }

  function applyTextStyle(overlay, data) {
    var style = textStyle(data);
    overlay.style.fontWeight = style.bold ? '700' : '400';
    overlay.style.fontStyle = style.italic ? 'italic' : 'normal';
    overlay.style.textDecoration = style.underline ? 'underline' : 'none';
    overlay.style.textAlign = style.align;
  }

  function syncText(key) {
    var data = state.texts[key];
    if (!data) return;
    $$('.ymm-cd-text[data-text="' + key + '"]').forEach(function (overlay) {
      var body = overlay.querySelector('.ymm-cd-text__body');
      if (overlay.classList.contains('ymm-cd-text--spine')) {
        var spine = overlay.closest('.ymm-cd-tray__spine');
        if (spine && data.bg) spine.style.background = data.bg;
        if (data.text) {
          overlay.hidden = false;
          if (body) {
            body.textContent = data.text;
            body.style.fontFamily = data.font || 'Jost';
          }
          overlay.style.color = data.color;
          overlay.style.fontFamily = data.font;
          overlay.style.setProperty('--ymm-spine-size', String(data.size || 18));
          applyTextStyle(overlay, data);
        } else {
          overlay.hidden = true;
          if (body) body.textContent = '';
        }
        return;
      }
      if (data.text) {
        overlay.hidden = false;
        if (body) {
          body.textContent = data.text;
          body.style.fontFamily = data.font || 'Jost';
        }
        overlay.style.left = data.x + '%';
        overlay.style.top = data.y + '%';
        overlay.style.width = data.w + '%';
        overlay.style.color = data.color;
        overlay.style.fontFamily = data.font;
        overlay.style.fontSize = data.size + 'px';
        applyTextStyle(overlay, data);
      } else {
        overlay.hidden = true;
        if (body) body.textContent = '';
      }
    });
  }

  function clampHex(hex) {
    var v = String(hex || '').trim();
    if (v.charAt(0) !== '#') v = '#' + v;
    if (/^#[0-9a-fA-F]{3}$/.test(v)) {
      v = '#' + v.charAt(1) + v.charAt(1) + v.charAt(2) + v.charAt(2) + v.charAt(3) + v.charAt(3);
    }
    return /^#[0-9a-fA-F]{6}$/.test(v) ? v.toLowerCase() : '#ffffff';
  }

  function hexToHsv(hex) {
    var h = clampHex(hex);
    var r = parseInt(h.slice(1, 3), 16) / 255;
    var g = parseInt(h.slice(3, 5), 16) / 255;
    var b = parseInt(h.slice(5, 7), 16) / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var hue = 0;
    if (d) {
      if (max === r) hue = ((g - b) / d) % 6;
      else if (max === g) hue = (b - r) / d + 2;
      else hue = (r - g) / d + 4;
      hue /= 6;
      if (hue < 0) hue += 1;
    }
    return { h: hue, s: max === 0 ? 0 : d / max, v: max };
  }

  function hsvToHex(h, s, v) {
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var r;
    var g;
    var b;
    switch (i % 6) {
      case 0: r = v; g = t; b = p; break;
      case 1: r = q; g = v; b = p; break;
      case 2: r = p; g = v; b = t; break;
      case 3: r = p; g = q; b = v; break;
      case 4: r = t; g = p; b = v; break;
      default: r = v; g = p; b = q;
    }
    function to(n) {
      var x = Math.round(n * 255).toString(16);
      return x.length === 1 ? '0' + x : x;
    }
    return '#' + to(r) + to(g) + to(b);
  }

  function hueHex(h) {
    return hsvToHex(h, 1, 1);
  }

  function bindDrag(el, onMove) {
    function point(e) {
      var t = e.touches && e.touches[0] ? e.touches[0] : e;
      var r = el.getBoundingClientRect();
      var x = (t.clientX - r.left) / r.width;
      var y = (t.clientY - r.top) / r.height;
      onMove(Math.max(0, Math.min(1, x)), Math.max(0, Math.min(1, y)));
    }
    function up() {
      document.removeEventListener('mousemove', point);
      document.removeEventListener('mouseup', up);
      document.removeEventListener('touchmove', point);
      document.removeEventListener('touchend', up);
    }
    el.addEventListener('mousedown', function (e) {
      e.preventDefault();
      point(e);
      document.addEventListener('mousemove', point);
      document.addEventListener('mouseup', up);
    });
    el.addEventListener('touchstart', function (e) {
      e.preventDefault();
      point(e);
      document.addEventListener('touchmove', point, { passive: false });
      document.addEventListener('touchend', up);
    }, { passive: false });
  }

  function mountPicker(wrap) {
    var hidden = wrap.querySelector('[data-color]');
    var sat = wrap.querySelector('[data-sv]');
    var satDot = wrap.querySelector('[data-sv-dot]');
    var hueEl = wrap.querySelector('[data-hue]');
    var hueThumb = wrap.querySelector('[data-hue-thumb]');
    var hexInput = wrap.querySelector('[data-hex]');
    if (!hidden || !sat) return hidden;
    var hsv = hexToHsv(hidden.value);

    function paint() {
      var hex = hsvToHex(hsv.h, hsv.s, hsv.v);
      hidden.value = hex;
      if (hexInput && document.activeElement !== hexInput) hexInput.value = hex;
      wrap.style.setProperty('--ymm-cd-hue', hueHex(hsv.h));
      satDot.style.left = (hsv.s * 100) + '%';
      satDot.style.top = ((1 - hsv.v) * 100) + '%';
      hueThumb.style.left = (hsv.h * 100) + '%';
    }

    bindDrag(sat, function (x, y) {
      hsv.s = x;
      hsv.v = 1 - y;
      paint();
      hidden.dispatchEvent(new Event('input', { bubbles: true }));
    });
    bindDrag(hueEl, function (x) {
      hsv.h = x;
      paint();
      hidden.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (hexInput) {
      hexInput.addEventListener('change', function () {
        hsv = hexToHsv(hexInput.value);
        paint();
        hidden.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
    paint();
    return hidden;
  }

  function bindTextPanel(plane) {
    [1, 2].forEach(function (n) {
      var key = plane + '-' + n;
      var box = $('.ymm-cd-textpanel[data-plane="' + plane + '"] [data-box="' + n + '"]');
      if (!box) return;
      var ta = box.querySelector('textarea');
      var font = box.querySelector('[data-font]');
      var size = box.querySelector('[data-size]');
      var picker = box.querySelector('[data-ymm-picker]');
      var color = picker ? mountPicker(picker) : box.querySelector('[data-color]');
      function push() {
        state.texts[key].text = ta.value;
        state.texts[key].font = font.value;
        state.texts[key].size = Number(size.value);
        state.texts[key].color = color.value;
        if (plane === 'disc') clampDisc(key);
        syncText(key);
        refreshCheckoutButtons();
        saveState();
      }
      ta.addEventListener('input', push);
      font.addEventListener('change', push);
      size.addEventListener('change', push);
      color.addEventListener('input', push);
      bindFormat(box, key, push);
      paintFormat(box, state.texts[key]);
    });
  }

  function bindSpine(side) {
    var key = side === 'l' ? 'back-sl' : 'back-sr';
    var box = $('.ymm-cd-textpanel[data-plane="back"] [data-spine-box="' + side + '"]');
    if (!box || !state.texts[key]) return;
    var ta = box.querySelector('textarea');
    var font = box.querySelector('[data-font]');
    var size = box.querySelector('[data-size]');
    var textPicker = box.querySelector('[data-ymm-picker]');
    var bgPicker = box.querySelector('[data-ymm-picker-bg]');
    var color = textPicker ? mountPicker(textPicker) : null;
    var bg = bgPicker ? mountPicker(bgPicker) : null;
    function push() {
      state.texts[key].text = ta.value;
      state.texts[key].font = font.value;
      state.texts[key].size = Number(size.value);
      if (color) state.texts[key].color = color.value;
      if (bg) state.texts[key].bg = bg.value;
      syncText(key);
      refreshCheckoutButtons();
      saveState();
    }
    ta.addEventListener('input', push);
    font.addEventListener('change', push);
    size.addEventListener('change', push);
    if (color) color.addEventListener('input', push);
    if (bg) bg.addEventListener('input', push);
    bindFormat(box, key, push);
    paintFormat(box, state.texts[key]);
  }

  function clampDisc(key) {
    var box = state.texts[key];
    var cx = box.x + box.w / 2;
    var cy = box.y + 10;
    var dx = cx - 50;
    var dy = cy - 50;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var minR = 16;
    var maxR = 38;
    if (dist < 0.1) {
      box.x = 50 + minR - box.w / 2;
      box.y = 32;
      return;
    }
    var a = Math.atan2(dy, dx);
    if (dist < minR) {
      box.x = 50 + Math.cos(a) * minR - box.w / 2;
      box.y = 50 + Math.sin(a) * minR - 8;
    } else if (dist > maxR) {
      box.x = 50 + Math.cos(a) * maxR - box.w / 2;
      box.y = 50 + Math.sin(a) * maxR - 8;
    }
  }

  function enableDrag() {
    var dragging = null;
    root.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.ymm-cd-text');
      if (!el || el.hidden || el.classList.contains('ymm-cd-text--spine') || el.classList.contains('ymm-cd-text--all')) return;
      var plane = el.closest('[data-plane]');
      if (!plane || !state.texts[el.getAttribute('data-text')]) return;
      dragging = {
        el: el,
        key: el.getAttribute('data-text'),
        plane: plane,
        ox: e.clientX,
        oy: e.clientY,
        sx: state.texts[el.getAttribute('data-text')].x,
        sy: state.texts[el.getAttribute('data-text')].y
      };
      el.setPointerCapture(e.pointerId);
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var rect = dragging.plane.getBoundingClientRect();
      var dx = ((e.clientX - dragging.ox) / rect.width) * 100;
      var dy = ((e.clientY - dragging.oy) / rect.height) * 100;
      var rec = state.texts[dragging.key];
      if (dragging.key === 'back-1' || dragging.key === 'back-2') {
        var maxX = Math.max(6, 94 - rec.w);
        rec.x = Math.min(maxX, Math.max(6, dragging.sx + dx));
        rec.y = Math.min(78, Math.max(4, dragging.sy + dy));
      } else {
        rec.x = Math.min(80, Math.max(2, dragging.sx + dx));
        rec.y = Math.min(82, Math.max(2, dragging.sy + dy));
      }
      if (dragging.key.indexOf('disc') === 0) clampDisc(dragging.key);
      syncText(dragging.key);
    });
    root.addEventListener('pointerup', function () {
      dragging = null;
      saveState();
    });
  }

  /* ---------- composite ---------- */

  function loadTextFonts(plane) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var keys = [plane + '-1', plane + '-2'];
    if (plane === 'back') keys.push('back-sl', 'back-sr');
    var jobs = [];
    keys.forEach(function (key) {
      var rec = state.texts[key];
      if (!rec || !String(rec.text || '').trim()) return;
      jobs.push(document.fonts.load(fontSpec(rec, 48), rec.text).catch(function () {}));
    });
    return Promise.all(jobs);
  }

  function compositePlane(plane) {
    var t = TARGET[plane];
    var rec = state.files[plane];
    var src = rec ? rec.preview : defaults[plane];
    if (!src) return Promise.resolve(null);
    return Promise.all([loadImage(src), loadTextFonts(plane)]).then(function (parts) {
      var img = parts[0];
      var canvas = document.createElement('canvas');
      canvas.width = t.w;
      canvas.height = t.h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, t.w, t.h);
      if (plane === 'back') drawBackSpines(ctx, t);
      [1, 2].forEach(function (n) {
        var key = plane + '-' + n;
        var box = state.texts[key];
        if (!box.text) return;
        var style = textStyle(box);
        var px = Math.round(box.size * (t.w / 520));
        var width = box.w / 100 * t.w;
        var left = box.x / 100 * t.w;
        var x = style.align === 'left' ? left : (style.align === 'right' ? left + width : left + width / 2);
        ctx.save();
        ctx.fillStyle = box.color;
        ctx.textAlign = style.align;
        ctx.textBaseline = 'top';
        ctx.font = fontSpec(box, px);
        wrapText(ctx, box.text, x, box.y / 100 * t.h, width, style.underline, px);
        ctx.restore();
      });
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) { resolve({ blob: blob, plane: plane }); }, 'image/jpeg', 0.92);
      });
    });
  }

  function underlineBox(ctx, text, x, y, px, baseline) {
    var w = ctx.measureText(text).width;
    var x0 = ctx.textAlign === 'left' ? x : (ctx.textAlign === 'right' ? x - w : x - w / 2);
    var top = baseline === 'middle' ? y + px * 0.38 : y + px * 0.95;
    ctx.fillRect(x0, top, w, Math.max(1, px * 0.06));
  }

  function drawBackSpines(ctx, t) {
    var spineW = Math.max(1, Math.round(t.w * (72 / 1624)));
    ['l', 'r'].forEach(function (side) {
      var box = state.texts[side === 'l' ? 'back-sl' : 'back-sr'];
      var x0 = side === 'l' ? 0 : t.w - spineW;
      ctx.fillStyle = (box && box.bg) || '#0b1426';
      ctx.fillRect(x0, 0, spineW, t.h);
      if (!box || !String(box.text || '').trim()) return;
      var style = textStyle(box);
      var maxW = t.h * 0.88;
      var x = style.align === 'left' ? -maxW / 2 : (style.align === 'right' ? maxW / 2 : 0);
      ctx.save();
      ctx.translate(x0 + spineW / 2, t.h / 2);
      ctx.rotate(side === 'l' ? -Math.PI / 2 : Math.PI / 2);
      ctx.fillStyle = box.color || '#ffffff';
      ctx.textAlign = style.align;
      ctx.textBaseline = 'middle';
      var px = Math.round((box.size || 18) * (t.w / 520));
      px = Math.min(Math.max(px, 12), Math.round(spineW * 0.82));
      ctx.font = fontSpec(box, px);
      fillCenteredLines(ctx, box.text, maxW, style.underline, px, x);
      ctx.restore();
    });
  }

  function fillCenteredLines(ctx, text, maxW, underline, px, x) {
    var words = String(text).split(/\s+/);
    var line = '';
    var lines = [];
    words.forEach(function (w) {
      var test = line ? line + ' ' + w : w;
      if (ctx.measureText(test).width > maxW && line) {
        lines.push(line);
        line = w;
      } else line = test;
    });
    if (line) lines.push(line);
    var size = px || parseInt(ctx.font, 10) || 16;
    var lh = size * 1.15;
    var start = -((lines.length - 1) * lh) / 2;
    var origin = x || 0;
    lines.forEach(function (ln, i) {
      var ly = start + i * lh;
      ctx.fillText(ln, origin, ly);
      if (underline && ln) underlineBox(ctx, ln, origin, ly, size, 'middle');
    });
  }

  function wrapText(ctx, text, x, y, maxW, underline, px) {
    var words = String(text).split(/\s+/);
    var line = '';
    var lines = [];
    words.forEach(function (w) {
      var test = line ? line + ' ' + w : w;
      if (ctx.measureText(test).width > maxW && line) {
        lines.push(line);
        line = w;
      } else line = test;
    });
    if (line) lines.push(line);
    var size = px || parseInt(ctx.font, 10) || 16;
    var lh = size * 1.15;
    lines.forEach(function (ln, i) {
      var ly = y + i * lh;
      ctx.fillText(ln, x, ly);
      if (underline && ln) underlineBox(ctx, ln, x, ly, size);
    });
  }

  /* ---------- cart ---------- */

  function extrasTotal() {
    var sum = 0;
    $$('.ymm-cd-addon input:checked').forEach(function (cb) {
      sum += Number(cb.getAttribute('data-price') || 0);
    });
    return sum;
  }

  function refreshPrice() {
    var n = qty();
    var unit = Number(cfg.price) || 0;
    var list = Number(cfg.compareAt) || 0;
    if (!list || list <= unit) list = Math.round(unit * 1799 / 1299);
    var saleUnit = Math.round(unit * (1 - volumeRate(n)));
    var extraCents = Math.round(extrasTotal() * 100);
    var line = saleUnit * n + extraCents;
    var save = Math.max(0, (list - saleUnit) * n);
    var pct = list > unit ? Math.round((1 - unit / list) * 100) : 0;
    var nowEl = $('[data-cd-now]');
    var compareEl = $('[data-cd-compare]');
    var savePct = $('[data-cd-save-pct]');
    var you = $('[data-cd-you-save]');
    var lineEl = $('[data-cd-line]');
    var instEl = $('[data-cd-install]');
    if (nowEl) nowEl.textContent = money(saleUnit);
    if (compareEl) compareEl.textContent = money(list);
    if (savePct) savePct.textContent = pct ? 'Save: ' + pct + '%' : '';
    if (you) you.textContent = money(save);
    if (lineEl) lineEl.textContent = money(line);
    if (instEl) instEl.textContent = money(Math.round(line / 4));
  }

  function addonItems() {
    var n = qty();
    var items = [];
    $$('.ymm-cd-addon input:checked').forEach(function (cb) {
      var id = cb.getAttribute('data-variant-id');
      if (id) items.push({ id: Number(id), quantity: n, properties: { _hidden: 'true' } });
    });
    return items;
  }

  function sourceUrl(plane) {
    var rec = state.files[plane];
    if (!rec || !rec.fileUrl) return '';
    if (rec.fileUrl.indexOf('blob:') === 0 || rec.fileUrl.indexOf('data:') === 0) return '';
    return rec.fileUrl;
  }

  function collectProperties(urls) {
    var props = { Product: 'CD Disc' };
    var planes = [['front', 'Front Cover'], ['insert', 'Inside Insert'], ['disc', 'CD Disc'], ['back', 'Back Cover']];
    function formatLine(t) {
      var style = textStyle(t);
      var marks = [];
      if (style.bold) marks.push('Bold');
      if (style.italic) marks.push('Italic');
      if (style.underline) marks.push('Underline');
      return (t.font || 'Jost') + ' · ' + (t.size || 28) + 'px · ' + (t.color || '#ffffff') + ' · ' + style.align + (marks.length ? ' · ' + marks.join(', ') : '');
    }
    planes.forEach(function (pair) {
      var composite = urls[pair[0]];
      var source = sourceUrl(pair[0]);
      if (composite) props[pair[1]] = composite;
      if (source && source !== composite) props[pair[1] + ' Upload'] = source;
      [1, 2].forEach(function (n) {
        var t = state.texts[pair[0] + '-' + n];
        if (!t || !String(t.text || '').trim()) return;
        var label = pair[1] + ' Text ' + n;
        props[label] = t.text;
        props[label + ' Format'] = formatLine(t);
      });
    });
    [['back-sl', 'Back Spine Left'], ['back-sr', 'Back Spine Right']].forEach(function (pair) {
      var t = state.texts[pair[0]];
      if (!t) return;
      if (String(t.text || '').trim()) {
        props[pair[1]] = t.text;
        props[pair[1] + ' Format'] = formatLine(t);
      }
      if (t.bg) props[pair[1] + ' Background'] = t.bg;
    });
    var order = orderInput();
    if (order && order.value) props[orderPropName()] = order.value.trim();
    return props;
  }

  function orderInput() {
    return $('[data-cd-order-input]');
  }

  function orderPropName() {
    var el = orderInput();
    if (!el) return 'Order Number';
    var name = el.getAttribute('name') || '';
    var m = name.match(/properties\[([^\]]+)\]/);
    return m ? m[1] : 'Order Number';
  }

  function orderValid() {
    var order = orderInput();
    if (!order) return true;
    return /^[0-9]{10}$/.test(String(order.value || '').trim());
  }

  function syncOrderError(forceShow) {
    var wrap = $('.ymm-cd-etsy');
    var order = orderInput();
    var err = $('.ymm-cd-etsy__error');
    var invalid = !!order && !orderValid();
    var show = forceShow === true ? invalid : (forceShow === false ? false : invalid && order.value);
    if (wrap) wrap.classList.toggle('is-invalid', !!show);
    if (err) err.style.display = show ? 'block' : 'none';
    if (order) order.setAttribute('aria-invalid', show ? 'true' : 'false');
    return !invalid;
  }

  function sanitizeOrderInput() {
    var order = orderInput();
    if (!order) return;
    var digits = String(order.value || '').replace(/\D/g, '').slice(0, 10);
    if (order.value !== digits) order.value = digits;
    if (orderValid()) syncOrderError(false);
  }

  function hasText() {
    return Object.keys(state.texts).some(function (key) {
      return state.texts[key] && String(state.texts[key].text || '').trim();
    });
  }

  function missingRequired() {
    var missing = [];
    if (!state.files.front) missing.push('front cover');
    if (!state.files.insert) missing.push('inside insert');
    if (!state.files.disc) missing.push('disc print');
    if (!state.files.back) missing.push('back cover');
    if (!hasText()) missing.push('text');
    return missing;
  }

  function isReady() {
    return missingRequired().length === 0;
  }

  function stepDone(num) {
    if (num === 1) return !!state.files.front;
    if (num === 2) return !!state.files.insert;
    if (num === 3) return !!state.files.disc;
    if (num === 4) return !!state.files.back;
    if (num === 5) return hasText();
    if (num === 7) {
      return $$('.ymm-cd-addon input:checked').length > 0;
    }
    return false;
  }

  function updateStepMarks() {
    $$('.ymm-cd-step').forEach(function (step) {
      var num = Number(step.getAttribute('data-step'));
      var done = stepDone(num);
      var required = num >= 1 && num <= 5;
      var skipped = required && !done && state.attemptedCheckout;
      step.classList.toggle('is-done', done);
      step.classList.toggle('is-missed', skipped);
    });
  }

  function refreshCheckoutButtons() {
    var ready = isReady();
    var atc = $('.ymm-cd-atc');
    var pay = $('[data-cd-shoppay]');
    [atc, pay].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !!state.adding;
      btn.classList.toggle('is-locked', !ready);
    });
    updateStepMarks();
  }

  function addToCart(goCheckout) {
    if (state.adding) return;
    if (!orderValid()) {
      syncOrderError(true);
      var lbl = orderPropName() === 'Etsy Order Number' ? 'Etsy order number' : 'order number';
      showError('Please enter your ' + lbl + ' (10 digits, numbers only).');
      var order = orderInput();
      if (order) {
        if (order.scrollIntoView) order.scrollIntoView({ behavior: 'smooth', block: 'center' });
        order.focus();
        if (order.reportValidity) order.reportValidity();
      }
      return;
    }
    var missing = missingRequired();
    if (missing.length) {
      state.attemptedCheckout = true;
      showError('Complete steps 1–5 first: ' + missing.join(', ') + '.');
      refreshCheckoutButtons();
      return;
    }
    state.adding = true;
    var btn = $('.ymm-cd-atc');
    var pay = $('[data-cd-shoppay]');
    var n = qty();
    var atcHtml = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Preparing…';
    if (pay) pay.disabled = true;

    Promise.all(['front', 'insert', 'disc', 'back'].map(compositePlane)).then(function (parts) {
      var uploads = parts.filter(Boolean).map(function (part) {
        return uploadFilestack(part.blob, 'ymm-cd-' + part.plane + '.jpg').then(function (url) {
          if (!url && state.files[part.plane] && state.files[part.plane].fileUrl) {
            url = state.files[part.plane].fileUrl;
          }
          return { plane: part.plane, url: url };
        });
      });
      return Promise.all(uploads);
    }).then(function (rows) {
      var urls = {};
      rows.forEach(function (r) { urls[r.plane] = r.url; });
      var items = [{
        id: Number(cfg.variantId),
        quantity: n,
        properties: collectProperties(urls)
      }].concat(addonItems());
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart error');
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      window.location.href = rootUrl + (goCheckout ? 'checkout' : 'cart');
    }).catch(function (err) {
      showError(err.message || 'Could not add to cart.');
      state.adding = false;
      refreshCheckoutButtons();
      btn.innerHTML = atcHtml;
    });
  }

  function showError(msg) {
    var el = $('.ymm-cd-error');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
  }

  /* ---------- boot ---------- */

  $$('.ymm-cd-step__head').forEach(function (btn) {
    btn.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
    btn.addEventListener('click', function () {
      var y = window.scrollY;
      toggleStep(Number(btn.parentNode.getAttribute('data-step')));
      var pin = function () {
        if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
      };
      pin();
      requestAnimationFrame(pin);
      setTimeout(pin, 0);
      setTimeout(pin, 50);
    });
  });

  $$('.ymm-cd-preview__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showSlide(btn.getAttribute('data-target'));
    });
  });

  $$('.ymm-cd-upload input').forEach(function (input) {
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      openCrop(file, input.getAttribute('data-plane'));
      input.value = '';
    });
  });

  $$('[data-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var plane = btn.getAttribute('data-edit');
      var input = $('.ymm-cd-upload[data-plane="' + plane + '"] input');
      if (input) input.click();
    });
  });

  var cropStage = $('.ymm-cd-crop__stage');
  if (cropStage) {
    cropStage.addEventListener('pointerdown', function (e) {
      if (!state.crop) return;
      state.crop.dragging = true;
      state.crop.lx = e.clientX;
      state.crop.ly = e.clientY;
      cropStage.setPointerCapture(e.pointerId);
    });
    cropStage.addEventListener('pointermove', function (e) {
      if (!state.crop || !state.crop.dragging) return;
      state.crop.x += e.clientX - state.crop.lx;
      state.crop.y += e.clientY - state.crop.ly;
      state.crop.lx = e.clientX;
      state.crop.ly = e.clientY;
      paintCrop();
    });
    cropStage.addEventListener('pointerup', function () {
      if (state.crop) state.crop.dragging = false;
    });
    cropStage.addEventListener('wheel', function (e) {
      if (!state.crop) return;
      e.preventDefault();
      state.crop.scale *= e.deltaY < 0 ? 1.06 : 0.94;
      paintCrop();
    }, { passive: false });
  }

  var cropOk = $('[data-crop-ok]');
  var cropNo = $('[data-crop-cancel]');
  if (cropOk) {
    cropOk.addEventListener('click', function () {
      var plane = state.crop.plane;
      var origW = state.crop.img.naturalWidth || state.crop.img.width;
      var origH = state.crop.img.naturalHeight || state.crop.img.height;
      var name = state.crop.file.name;
      exportCrop().then(function (payload) {
        applyUpload(plane, payload, origW, origH, name);
        closeCrop();
      });
    });
  }
  if (cropNo) cropNo.addEventListener('click', closeCrop);

  $$('.ymm-cd-tabs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var plane = btn.getAttribute('data-text-plane');
      $$('.ymm-cd-tabs button').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      $$('.ymm-cd-textpanel').forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-plane') === plane);
      });
      showSlide(plane === 'insert' ? 'insert' : plane);
    });
  });

  ['front', 'insert', 'disc', 'back'].forEach(bindTextPanel);
  bindSpine('l');
  bindSpine('r');
  enableDrag();
  $$('.ymm-cd-addon input').forEach(function (cb) {
    cb.addEventListener('change', function () {
      refreshPrice();
      updateStepMarks();
      saveState();
    });
  });
  var minus = $('[data-qty-minus]');
  var plus = $('[data-qty-plus]');
  var qtyInput = $('[data-cd-qty]');
  if (minus) minus.addEventListener('click', function () { qtyInput.value = qty() - 1; refreshPrice(); saveState(); });
  if (plus) plus.addEventListener('click', function () { qtyInput.value = qty() + 1; refreshPrice(); saveState(); });
  if (qtyInput) qtyInput.addEventListener('change', function () { refreshPrice(); saveState(); });
  var orderField = orderInput();
  if (orderField) {
    orderField.addEventListener('input', function () {
      sanitizeOrderInput();
      saveState();
    });
    orderField.addEventListener('blur', function () {
      if (orderField.value) syncOrderError(true);
    });
  }
  $('.ymm-cd-atc').addEventListener('click', function () {
    addToCart(false);
  });
  var shopPay = $('[data-cd-shoppay]');
  if (shopPay) shopPay.addEventListener('click', function () {
    addToCart(true);
  });
  var payform = $('.ymm-cd-payform');
  if (payform) payform.addEventListener('submit', function (e) { e.preventDefault(); });
  var restored = restoreState();
  refreshPrice();
  refreshCheckoutButtons();
  openStep(1, false);
  if (restored && restored.slide) {
    showSlide(restored.slide);
  } else if (state.files.front) {
    showSlide('front');
  } else if (state.files.insert) {
    showSlide('insert');
  } else if (state.files.disc) {
    showSlide('disc');
  } else {
    showSlide('product');
  }

  function syncStickyTop() {
    if (window.matchMedia && !window.matchMedia('(min-width: 990px)').matches) {
      root.style.removeProperty('--ymm-cd-sticky-top');
      return;
    }
    var header = document.querySelector('.t4s-section-header') || document.querySelector('header');
    var top = 12;
    if (header) {
      var box = header.getBoundingClientRect();
      top = Math.max(12, Math.round(box.bottom) + 8);
    }
    root.style.setProperty('--ymm-cd-sticky-top', top + 'px');
  }

  syncStickyTop();
  window.addEventListener('scroll', syncStickyTop, { passive: true });
  window.addEventListener('resize', syncStickyTop);
})();
